const countryOfficesLoadMore = {
    init() {
        document.querySelectorAll('.country-offices__load-more-btn').forEach(function (button) {
            button.addEventListener('click', function () {
                const wrap = button.closest('.country-offices');
                const grid = wrap && wrap.querySelector('.country-offices__grid');

                if (! grid) {
                    return;
                }

                grid.querySelectorAll('.country-offices__card--hidden').forEach(function (card) {
                    card.classList.remove('country-offices__card--hidden');
                });

                button.closest('.country-offices__load-more').remove();
            });
        });
    }
}

export default countryOfficesLoadMore
